import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {RestService} from '../services/rest.service';
import {UIBlockerService} from '../services/uiblocker.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from '../services/data.service';
import {SessionStorageService} from '../services/session-storage.service';
import {finalize, tap} from 'rxjs/operators';
import {NgForm} from '@angular/forms';
import {AdminLoginResponse} from '../models/api.models';
import {isNullOrUndefined} from '../shared/is-null-or-undefined';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {

    sessionId?: string;
    loginResponse?: AdminLoginResponse;
    loginFailed = false;

    constructor(
        private restService: RestService,
        private uiBlockerService: UIBlockerService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private dataService: DataService,
        private localStorage: SessionStorageService
    ) {
    }

    ngOnInit() {

        this.getDataFromLocalStorage();
    }

    getDataFromLocalStorage() {
        this.localStorage.getItem<string>('SessionIdentifier').subscribe((data) => {
            if (!isNullOrUndefined(data) && data !== '') {
                this.checkSessionIdOnServer(data);
            }
        });
    }

    checkSessionIdOnServer(data: string) {

        this.restService.checkSession(data)
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                }),
                tap({
                    error: () => {
                        this.localStorage.clear().subscribe(() => undefined);
                    }
                })
            ).subscribe((res) => {
            if (this.dataService.isResponseSuccessful(res) && res.UserInfo) {
                this.dataService.setUserInfo(res.UserInfo);
                void this.router.navigateByUrl(this.getDestinationUrl());
            } else {

                this.localStorage.clear().subscribe(() => undefined);
            }
        });
    }

    onSignin(form: NgForm) {

        this.loginFailed = false;
        if (form.valid) {
            this.uiBlockerService.blockUI();
            const user = form.value.username;
            const password = form.value.password;

            const userCredentials = {
                Username: user,
                Password: password
            };

            this.restService.login(userCredentials)
                .pipe(
                    finalize(() => {
                        this.uiBlockerService.unBlockUI();
                    }),
                    tap({
                        error: () => {
                            this.loginFailed = true;
                        }
                    })
                ).subscribe((res) => {
                if (this.dataService.isResponseSuccessful(res) && res.UserInfo) {

                    this.dataService.setUserInfo(res.UserInfo);

                    this.localStorage.setItem('SessionIdentifier', res.UserInfo.SessionIdentifier).subscribe(
                        () => undefined);

                    void this.router.navigateByUrl(this.getDestinationUrl());
                } else {

                    this.loginFailed = true;
                }
            });
        }

    }

    private getDestinationUrl(): string {
        const returnUrl = this.activatedRoute.snapshot.queryParamMap.get('returnUrl') || '';
        return returnUrl === '/central' || returnUrl.startsWith('/central/')
            ? returnUrl
            : '/central/overview';
    }

}
